import React from "react";

const PackagingExport = ({ formData, setFormData }) => {
  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };
  return (
    <div className="border border-gray-300 rounded-md overflow-hidden ">
      <div className="grid grid-cols-2">
        {/* OUTER CARTON */}
        <div className="border-r border-gray-300">
          <div className="px-3 py-2 bg-gray-100 font-semibold text-sm border-b border-gray-300">
            Outer Carton
          </div>

          <div className="p-4 space-y-4 text-sm">
            {/* FIELD ROW */}
            <div>
              <label className="text-xs font-semibold">
                Gross Weight [OC]{" "}
                <span className="text-orange-500">(In KG)</span>
              </label>
              <input
                type="number"
                value={formData.ocGrossWeight || ""}
                onChange={(e) => handleChange("ocGrossWeight", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="Enter Gross Weight"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Net Weight [OC] <span className="text-orange-500">(In KG)</span>
              </label>
              <input
                type="number"
                value={formData.ocNetWeight || ""}
                onChange={(e) => handleChange("ocNetWeight", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="Enter Net Weight"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Carton Size [OC]{" "}
                <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="text"
                value={formData.ocCartonSize || ""}
                onChange={(e) => handleChange("ocCartonSize", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="L × B × H"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">Pcs/Box [OC]</label>
              <input
                type="number"
                value={formData.ocPcsBox || ""}
                onChange={(e) => handleChange("ocPcsBox", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="Enter Quantity"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Length [OC] <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="number"
                value={formData.ocLength || ""}
                onChange={(e) => handleChange("ocLength", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="Length"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Breadth [OC] <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="number"
                value={formData.ocBreadth || ""}
                onChange={(e) => handleChange("ocBreadth", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="Breadth"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Height [OC] <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="number"
                value={formData.ocHeight || ""}
                onChange={(e) => handleChange("ocHeight", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="Height"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                CBM/Master Carton [OC]
              </label>
              <input
                type="number"
                value={formData.ocCbm || ""}
                onChange={(e) => handleChange("ocCbm", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="CBM"
              />
            </div>
          </div>
        </div>

        {/* INNER CARTON */}
        <div>
          <div className="px-3 py-2 bg-gray-100 font-semibold text-sm border-b border-gray-300">
            Inner Carton
          </div>

          <div className="p-4 space-y-4 text-sm">
            <div>
              <label className="text-xs font-semibold">
                Weight [IC] <span className="text-orange-500">(In KG)</span>
              </label>
              <input
                type="number"
                value={formData.icWeight || ""}
                onChange={(e) => handleChange("icWeight", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Carton Size [IC]{" "}
                <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="text"
                value={formData.icCartonSize || ""}
                onChange={(e) => handleChange("icCartonSize", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
                placeholder="L × B × H"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Qty/Inner Box [IC]
              </label>
              <input
                type="number"
                value={formData.icQtyBox || ""}
                onChange={(e) => handleChange("icQtyBox", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Length [IC] <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="number"
                value={formData.icLength || ""}
                onChange={(e) => handleChange("icLength", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Breadth [IC] <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="number"
                value={formData.icBreadth || ""}
                onChange={(e) => handleChange("icBreadth", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                Height [IC] <span className="text-orange-500">(In CM)</span>
              </label>
              <input
                type="number"
                value={formData.icHeight || ""}
                onChange={(e) => handleChange("icHeight", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
              />
            </div>

            <div>
              <label className="text-xs font-semibold">
                CBM/Inner Box [IC]
              </label>
              <input
                type="number"
                value={formData.icCbm || ""}
                onChange={(e) => handleChange("icCbm", e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-100 border border-gray-200 rounded"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackagingExport;
